import Barcode from "react-barcode";
export default function BarCodeComp({
  params,
}: {
  params: {
    code: any;
    size?: number;
    bgcolor?: string;
    color?: string;
  };
}) {
  const { code, size, bgcolor, color } = params;
  return typeof code === "string" && code !== "" ? (
    <Barcode
      value={code}
      fontSize={size}
      background={bgcolor}
      lineColor={color}
      className={"barcodeSVG"}
    />
  ) : (
    <></>
  );
}
